import CheckCircleRounded from '@mui/icons-material/CheckCircleRounded';
import styles from './BenefitsSection.module.css';

/**
 * Who it helps and how - one list per audience. Brought onto the homepage from the South African "Benefits"
 * page, which was two short lists on a page of their own.
 */
export default function BenefitsSection({content}) {
    return (
        <section id="ch-home-benefits" className={styles.section} aria-labelledby="home-benefits">
            <div className={styles.inner}>
                <h2 id="home-benefits" className={styles.heading}>{content.heading}</h2>
                <div className={styles.groups}>
                    {content.groups.map((group) => (
                        <div key={group.heading} className={styles.group}>
                            <h3 className={styles.groupHeading}>{group.heading}</h3>
                            <ul className={styles.list}>
                                {group.items.map((item) => (
                                    <li key={item}>
                                        <CheckCircleRounded className={styles.icon} aria-hidden="true"/>
                                        <span>{item}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
